import script from "./UncertantyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UncertantyComponent.vue?vue&type=script&setup=true&lang=js"

import "./UncertantyComponent.vue?vue&type=style&index=0&id=7d1113d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1113d0"]])

export default __exports__